// src/OrgChartNode.jsx (Updated to handle grouping)
import React from 'react';
import styles from './css/org.module.css'; // Use the module name

// Utility to render a group of R/V nodes under a custom heading
const renderRVGroup = (group, heading) => {
    if (!group.length) return null;
    return (
        <li className={styles.rvGroupContainer}>
            {/* Custom Heading for the group */}
            <div className={styles.groupHeader}>**{heading}**</div> 
            <ul className={styles.nodeList}>
                {group.map(node => (
                    <li key={node.id} className={styles.nodeItem}>
                         <div className={styles.personCard}>
                            <div className={styles.name}>{node.name}</div>
                            <div className={styles.role}>({node.type})</div>
                        </div>
                    </li>
                ))}
            </ul>
        </li>
    );
};


const OrgChartNode = ({ node }) => {
  const hasChildren = node.children && node.children.length > 0;

  // ------------------------------------------------------------------
  // 1. Special Handling for SM Level (to group Recruiter/Vendor children)
  // ------------------------------------------------------------------
  if (node.role === "SM" && hasChildren) {
    const recruiters = node.children.filter(c => c.type === 'Recruiter');
    const vendors = node.children.filter(c => c.type === 'Vendor');
    
    return (
      <li className={styles.nodeItem}>
          <div className={styles.personCard}>
              <div className={styles.name}>{node.name}</div>
              <div className={styles.role}>({node.role})</div>
          </div>
          
          {/* Render the R/V groups as siblings */}
          <ul className={styles.nodeList}>
            {renderRVGroup(recruiters, "All Recruiters")}
            {renderRVGroup(vendors, "All Vendors")}
          </ul>
      </li>
    );
  }

  // ------------------------------------------------------------------
  // 2. Default Rendering for BD, SH, and any other standard node
  // ------------------------------------------------------------------
  return (
    <li className={styles.nodeItem}>
      
      <div className={styles.personCard}>
        <div className={styles.name+  node.status === "reject"  ? styles.statusRejected : styles.statusActive}>{node.name}</div>
        <div className={styles.role}>({node.role})</div>
        {node.assign_date && (
        <div className={styles.date}>
            {node.assign_date}
        </div>
    )}
      </div>
 
      {hasChildren && (
        <ul className={styles.nodeList}>
          {node.children.map((childNode) => (
            <OrgChartNode 
              key={childNode.id} 
              node={childNode} 
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default OrgChartNode;